import { render, staticRenderFns } from "./AnimalSelect.vue?vue&type=template&id=535f2c75"
import script from "./AnimalSelect.vue?vue&type=script&lang=js"
export * from "./AnimalSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports